import axios from './Interceptor.js';
let address = window.global_config.BASE_URL2;

let derive = {
  ProjectListData: info => {
    return axios({
      method: 'post',
      url: `${address}Project/GetList`,
      data: info
    });
  },
  CRFSurfaceData: info => {
    return axios({
      method: 'post',
      url: `${address}QuestionnaireCenter/List`,
      data: info
    });
  },
  QuestionnaireTokenData: () => {
    //获取问卷系统token
    return axios({
      method: 'post',
      url: `${address}QuestionnaireCenter/GetConfig`
    });
  },
  FollowUpRecordsData: info => {
    //项目患者随访记录
    return axios({
      method: 'post',
      url: `${address}PatientCenter/FollowUp/GetPageList`,
      data: info
    });
  },
  SeeFollowUpRecordsData: () => {
    //查看项目患者随访记录
    return axios({
      method: 'post',
      url: `${address}PatientCenter/Questionnaire/Get`
    });
  },
  EditFollowUpRecordsData: () => {
    //编辑项目患者随访记录
    return axios({
      method: 'post',
      url: `${address}PatientCenter/Questionnaire/Edit`
    });
  },
  DeleteFollowUpRecordsData: info => {
    //删除项目患者随访记录
    return axios({
      method: 'post',
      url: `${address}PatientCenter/Questionnaire/Delete`,
      data: info
    });
  },
  CollectedExportData: info => {
    //已收集问卷导出
    return axios({
      method: 'post',
      url: `${address}PatientCenter/Questionnaire/Collected/Export`,
      data: info,
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob'
    });
  },
  PatientExportData: info => {
    //患者查询导出
    return axios({
      method: 'post',
      url: `${address}PatientCenter/Export`,
      data: info,
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob'
    });
  },
  PatientGetIdListData: info => {
    //[患者id数组]
    return axios({
      method: 'post',
      url: `${address}PatientCenter/GetIdList`,
      data: info
    });
  },
  PatientCenterGet: id => {
    //[患者id数组]
    return axios({
      method: 'get',
      url: `${address}PatientCenter/Get?id=${id}`
    });
  },
  inspectPageList: data => {
    return axios({
      method: 'post',
      url: `${address}FollowUp/Check/Comment/GetPageList`,
      data
    });
  },
  addInspect: data => {
    return axios({
      method: 'post',
      url: `${address}FollowUp/Check/Comment/Add`,
      data
    });
  },
  delInspect: data => {
    return axios({
      method: 'post',
      url: `${address}FollowUp/Check/Comment/Delete`,
      data
    });
  },
  editInspect: data => {
    return axios({
      method: 'post',
      url: `${address}FollowUp/Check/Comment/Edit`,
      data
    });
  },
  LifeData: id => {
    return axios({
      method: 'get',
      url: `${address}DataMappingLog/GetPatientIdByDataSynchronization?PatientId=${id}`
    });
  },
  lifeLine: id => {
    return axios({
      method: 'get',
      url: `${address}DataMappingLog/GetPatientSynLogByPatientId?PatientId=${id}`
    });
  },
  setDataApi: data => {
    return axios({
      method: 'post',
      url: `${address}QuestionnaireCenter/SynchronousData?ProjectId=${data.ProjectId}`,
      data
    });
  },
  RWPDGLList: data => {
    return axios({
      method: 'post',
      url: `${address}DataMappingLog/GetTaskMappingPageList`,
      data
    });
  },
  // 数据集同步问卷
  QuestionSynDateSet: data => {
    return axios({
      method: 'get',
      url: `${address}DataSetStandard/QuestionSynDateSet?Id=${data.Id}&Qid=${data.Qid}`,
      data
    });
  }
};

export default derive;
